import React from 'react';

import JobReferralsNewReferralPage from '../../../js/pages/JobReferralsNewReferralPage';
import {withAuthentication} from '../../../js/components/Routes';
import {getTags} from '../../../../server/services/tags';

const AuthedPage = withAuthentication(JobReferralsNewReferralPage);

export default function Page(props) {
  return <AuthedPage {...props} />;
}

export async function getServerSideProps({query}) {
  const tags = (await getTags()).allTags;

  return {
    props: {
      company: tags[query?.company] || null,
    },
  };
}

